(function () {
    "use strict";

    /**
     * Handle WayPoint class additions
     * @param string direction       Scroll direction
     * @param string windowPosition  Top/Bottom came into view
     * @param string elementPosition Top/Bottom came into view
     * @param null
     */
    function addWaypointClasses(direction, windowPosition, elementPosition, element) {
        // Remove all the waypoint prefixed classes
        jQuery(element).removeClass(function () {
            return (jQuery(this).attr('class').match(/(^|\s)waypoint-\S+/g) || []).join(' ');
        });

        // Re-add the enabled class
        jQuery(element).addClass('waypoint-enabled');
        // Add triggered class for one-time waypoints
        jQuery(element).addClass('waypoint-triggered');

        // Ensure the element is at least partially in the viewport
        if ((direction !== 'up' || windowPosition !== 'bottom' || elementPosition !== 'top') &&
                (direction !== 'down' || windowPosition !== 'top' || elementPosition !== 'bottom')) {

            // Add a visible class for generic waypoints
            // (not dependent on direction or window/element position)
            jQuery(element).addClass('waypoint-visible');
            // Add directional and positional classes
            jQuery(element).addClass('waypoint-' + direction);
            jQuery(element).addClass('waypoint-window-' + windowPosition);
            jQuery(element).addClass('waypoint-element-' + elementPosition);
        }
    }

    /**
     * jQuery function for adding waypoint classes
     * to elements. Hooking into waypoints.js
     * @return jQuery Object    Element (chaining)
     */
    jQuery.fn.waypointClasses = function () {
        // Add an enabled class for JS conditional
        jQuery(this).addClass('waypoint-enabled');

        // Window Top / Element Top positional handler
        jQuery('.waypoint-enabled').waypoint({
            handler: function (direction) {
                addWaypointClasses(direction, 'top', 'top', this.element);
            }
        });

        // Window Top / Element Bottom positional handler
        jQuery('.waypoint-enabled').waypoint({
            // Modify offset for negative handling
            offset: function () {
                return -this.element.clientHeight;
            },
            handler: function (direction) {
                addWaypointClasses(direction, 'top', 'bottom', this.element);
            }
        });

        // Window Bottom / Element Top positional handler
        jQuery('.waypoint-enabled').waypoint({
            offset: '100%',
            handler: function (direction) {
                addWaypointClasses(direction, 'bottom', 'top', this.element);
            }
        });

        // Window Bottom / Element Bottom positional handler
        jQuery('.waypoint-enabled').waypoint({
            offset: 'bottom-in-view',
            handler: function (direction) {
                addWaypointClasses(direction, 'bottom', 'bottom', this.element);
            }
        });

        // Return the jQuery element
        return this;
    };
}());
